import React, { useMemo } from 'react';

import usePaymentsMVPEnabled from 'Utilities/hooks/usePaymentsMVPEnabled';
import useUser from 'Utilities/hooks/useUser';

import { MotorwayPayModulr } from './MotorwayPayModulr';
import type { MotorwayPayModulrProps } from './MotorwayPayModulr.helper';

export const MotorwayPayModulrPage: React.FC = () => {
	const isPaymentsMVPEnabled = usePaymentsMVPEnabled();
	const { isLoggedOut } = useUser();

	const resolveDisplayAs = useMemo((): MotorwayPayModulrProps['displayAs'] => {
		if (isLoggedOut) {
			return 'signedOut';
		}

		if (isPaymentsMVPEnabled) {
			return 'signedInWithPayment';
		}

		return 'signedInWithoutPayment';
	}, [isLoggedOut, isPaymentsMVPEnabled]);

	return <MotorwayPayModulr displayAs={resolveDisplayAs} />;
};
